/**
 * Loading spinner component.
 */
import * as stylex from "@stylexjs/stylex";

import { colors } from "../tokens.stylex";

const spin = stylex.keyframes({
  from: { transform: "rotate(0deg)" },
  to: { transform: "rotate(360deg)" },
});

const styles = stylex.create({
  base: {
    height: 32,
    width: 32,
    animationName: spin,
    animationDuration: "1s",
    animationIterationCount: "infinite",
    animationTimingFunction: "linear",
    borderRadius: "50%",
    borderWidth: 2,
    borderStyle: "solid",
    borderColor: colors.primary,
    borderTopColor: colors.transparent,
  },
  sm: {
    height: 16,
    width: 16,
    borderWidth: 2,
  },
  lg: {
    height: 48,
    width: 48,
    borderWidth: 3,
  },
});

type SpinnerSize = "sm" | "default" | "lg";

interface SpinnerProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: SpinnerSize;
  xstyle?: stylex.StyleXStyles;
}

function Spinner({ size = "default", xstyle, ...props }: SpinnerProps) {
  return (
    <div
      {...stylex.props(styles.base, size !== "default" && styles[size], xstyle)}
      {...props}
    />
  );
}

// Export styles for direct use
export const spinner = styles;

export { Spinner, type SpinnerProps, type SpinnerSize };
